/** Sichtbare Strichstärke in CSS-Pixeln. In Bitmap-Pixel umgerechnet, nicht per ctx.scale. */
export const SIGNATURE_STROKE_CSS_PX = 2.5;

/** Obergrenze, damit das PNG auf 3x-Displays nicht unnötig groß wird. */
export const SIGNATURE_MAX_DPR = 2;

export type SignatureCssRect = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export function signatureBackingStoreSize(
  cssWidth: number,
  cssHeight: number,
  devicePixelRatio: number,
): { width: number; height: number; scale: number } {
  const scale = Math.min(Math.max(devicePixelRatio || 1, 1), SIGNATURE_MAX_DPR);
  return {
    width: Math.max(1, Math.round(cssWidth * scale)),
    height: Math.max(1, Math.round(cssHeight * scale)),
    scale,
  };
}

/**
 * Zeigerposition in Bitmap-Pixeln.
 * Genau einmal mit canvas/angezeigter Größe skalieren. Ein zusätzliches ctx.scale(dpr)
 * schiebt den Strich auf Smartphones (dpr 2–3) aus dem sichtbaren Feld.
 */
export function pointerToCanvasPoint(
  clientX: number,
  clientY: number,
  rect: SignatureCssRect,
  canvasWidth: number,
  canvasHeight: number,
): { x: number; y: number } {
  const scaleX = rect.width > 0 ? canvasWidth / rect.width : 1;
  const scaleY = rect.height > 0 ? canvasHeight / rect.height : 1;
  return {
    x: (clientX - rect.left) * scaleX,
    y: (clientY - rect.top) * scaleY,
  };
}

export function imageDataHasInk(data: Uint8ClampedArray): boolean {
  for (let i = 3; i < data.length; i += 4) {
    const alpha = data[i];
    if (alpha !== undefined && alpha > 0) return true;
  }
  return false;
}
